import { RouterProvider, createBrowserRouter, createMemoryRouter } from 'react-router-dom';
import { useMemo } from 'react';
import EveThemeProvider from '@ashn/eve-themes-react/EveThemeProvider';
import AppContext from './components/shared/AppContext';
import useReactRoutes from './components/shared/useReactRoutes';

const routerCreate =
	process.env.NODE_ENV === 'test' ? createMemoryRouter : createBrowserRouter;

const App = () => {
	const routes = useReactRoutes();

	const router = useMemo(() => routerCreate(routes), [routes]);

	// TO-DO: if feature flags grow consider refactoring to conditionally wrap with AppContext
	return (
		<EveThemeProvider themeKey="ashcare" themeMode="light">
			<AppContext>
				<RouterProvider router={router} />
			</AppContext>
		</EveThemeProvider>
	);
};

export default App;
